import React, { createContext, useContext, useState } from 'react'

const SupportPageContext = createContext()
export const useSupportPageContext = () => useContext(SupportPageContext)
export function SupportPageProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <SupportPageContext.Provider
      value={{
        isOpen,
        setIsOpen,
      }}
    >
      {children}
    </SupportPageContext.Provider>
  )
}
